<template lang="pug">
div.wrap-img-to-line-art-converter
  //- span(@click="generateLineArt").cursor-pointer generateLineArt
  //- div.hide
    canvas(ref="resultCanvas")#resultCanvas

  div.wrap-result-img.f.fh
    img(v-if="resultBase64" :src="resultBase64").object-fit-cover

  div.hide
    canvas(ref="resultCanvas")#resultCanvas
    canvas(ref="inputCanvas")#inputCanvas
    canvas(ref="screenCanvas")#screenCanvas
    canvas(ref="smoothingCanvas")#smoothingCanvas
  div.hide
    canvas(ref="lineArtCanvas")#lineArtCanvas
  div.hide
    canvas(ref="betaCanvas")#betaCanvas
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-img-to-line-art-converter {
  height: 100%;
  .wrap-result-img {
    height: 100%;
    img {
      max-height: 50vh;
      // height: 100%;
    }
  }
}
</style>

<script>
/* globals cv */
export default {
  props: {
    baseImgURL: {
      type: String,
      required: true
    },
    screen: {
      type: String,
      default: 'no_screen.png'
    },
    cannyParam: {
      type: Object,
      required: true
    },
    grayScaleParam: {
      type: Object,
      required: true
    }
  },
  computed: {
    screenURL () {
      return `/img/screen/${this.screen}`
    }
  },
  watch: {
    // screen () {
    //   this.generateLineArt()
    // },
    // cannyParam: {
    //   handler () {
    //     this.convertImageToLineDrawing('smoothingCanvas', 'lineArtCanvas')
    //     this.showResultImage()
    //   },
    //   deep: true
    // }
  },
  data () {
    return {
      file: null,
      // sampleImg: 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/sample%2Fbase8.jpeg?alt=media&token=63f82a79-fceb-4738-acbc-4ad578b14492'
      resultBase64: null
    }
  },
  async mounted () {
    await this.load(this, 'inputCanvas', this.baseImgURL)
    this.generateLineArt()
  },
  methods: {
    async generateLineArt () {
      // console.log('generateLineArt')
      await this.createScreenCanvas('inputCanvas', 'screenCanvas')
      this.makeImageSmooth('inputCanvas', 'smoothingCanvas')
      this.convertImageToLineDrawing('smoothingCanvas', 'lineArtCanvas')
      this.betaDetector('inputCanvas', 'betaCanvas')
      await this.createResultImage(['lineArtCanvas', 'betaCanvas'])
      this.showResultImage()
    },
    async load (self, canvasId, imgURL) {
      const image = await this.loadImage(imgURL, 'Anonymous').catch(e => {
        console.log('onload error', e)
      })

      const canvas = self.$refs[canvasId]
      const ctx = canvas.getContext('2d')
      const THUMBNAIL_WIDTH = 1200
      const THUMBNAIL_HEIGHT = 1200

      let width, height, ratio
      if (image.width > image.height) {
        // 横長の画像は横のサイズを指定値にあわせる
        ratio = image.height / image.width
        width = THUMBNAIL_WIDTH
        height = THUMBNAIL_WIDTH * ratio
      } else {
        // 縦長の画像は縦のサイズを指定値にあわせる
        ratio = image.width / image.height
        width = THUMBNAIL_HEIGHT * ratio
        height = THUMBNAIL_HEIGHT
      }
      canvas.width = width
      canvas.height = height

      ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
    },
    async createScreenCanvas (inputCanvasId, outputCanvasId) {
      const inputCanvas = this.$refs[inputCanvasId]

      const screenCanvas = this.$refs[outputCanvasId]
      const ctx = screenCanvas.getContext('2d')
      screenCanvas.width = inputCanvas.width
      screenCanvas.height = inputCanvas.height

      const image = await this.loadImage(this.screenURL).catch(e => {
        console.log('onload error', e)
      })

      for (let x = 0; x < Math.ceil(screenCanvas.width/image.width); x++) {
        for (let y = 0; y < Math.ceil(screenCanvas.height/image.height); y++) {
          ctx.drawImage(image, x * image.width, y * image.height)
        }
      }
    },
    // 平滑化（ブラー）
    makeImageSmooth (inputCanvasId, outputCanvasId) {
      const src = cv.imread(inputCanvasId)
      const dst = new cv.Mat()
      const ksize = new cv.Size(2, 2)
      const anchor = new cv.Point(-1, -1)
      cv.blur(src, dst, ksize, anchor, cv.BORDER_DEFAULT)
      // cv.boxFilter(src, dst, -1, ksize, anchor, true, cv.BORDER_DEFAULT)
      cv.imshow(outputCanvasId, dst)
      src.delete()
      dst.delete()
    },
    // 線画生成
    convertImageToLineDrawing (inputCanvasId, outputCanvasId) {
      const src = cv.imread(inputCanvasId)
      const dst = new cv.Mat()
      // グレースケース化
      cv.cvtColor(src, src, cv.COLOR_RGB2GRAY, 0)
      // You can try more different parameters: https://docs.opencv.org/3.4/d7/de1/tutorial_js_canny.html
      // cv.Canny(src, dst, 50, 100, 3, false)
      const param = this.cannyParam
      // console.log('changeCannyParam:', this.cannyParam.threshold)
      cv.Canny(src, dst, param.threshold[0], param.threshold[1], param.apertureSize, param.L2gradient)

      // 色の反転
      const contourDst = new cv.Mat()
      cv.bitwise_not(dst, contourDst)

      cv.imshow(outputCanvasId, contourDst)
      src.delete()
      dst.delete()      
    },
    // 3色のグレースケールに変換
    convertImageToThreeGrayScale (canvasId) {
      const canvas = this.$refs[canvasId]
      const ctx = canvas.getContext('2d')

      // キャンバス全体のピクセル情報を取得
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
      const width = imageData.width
      const height = imageData.height
      const pixels = imageData.data // ピクセル配列：RGBA4要素で1ピクセル

      const areaValues = this.grayScaleParam.areaValues
      const pallete = this.grayScaleParam.pallete
      for (let y = 0; y < height; ++y) {
        for (let x = 0; x < width; ++x) {
          const base = (y * width + x) * 4
          let grayScale

          // 0 178 230 255
          // const areaValues = [60, 120, 190]
          // if (pixels[base + 0] < areaValues[0]) {
          //   grayScale = 0
          // } else if (areaValues[0] <= pixels[base + 0] && pixels[base + 0] < areaValues[1]) {
          //   grayScale = 178
          // } else if (areaValues[1] <= pixels[base + 0] && pixels[base + 0] < areaValues[2]) {
          //   grayScale = 230
          // } else {
          //   grayScale = 255
          // }

          if (pixels[base + 0] < areaValues[0]) {
            grayScale = pallete[0] // 0
          } else if (areaValues[0] <= pixels[base + 0] && pixels[base + 0] < areaValues[1]) {
            grayScale = pallete[1] // 178
          } else {
            grayScale = pallete[2] // 255
          }

          for (let i = 0; i < 3; i++) {
            pixels[base + i] = grayScale
          }
          pixels[base + 3] = (grayScale === 255) ? 0 : 255
        }
      }

      const outputCanvas = this.$refs[canvasId]
      outputCanvas.width = width
      outputCanvas.height = height
      const outputCtx = outputCanvas.getContext('2d')
      outputCtx.putImageData(imageData, 0, 0)
    },
    // ベタの検出
    betaDetector (inputCanvasId, outputCanvasId) {
      const src = cv.imread(inputCanvasId)
      const dst = new cv.Mat()
      cv.cvtColor(src, dst, cv.COLOR_RGBA2GRAY)

      cv.imshow(outputCanvasId, dst)
      src.delete()
      dst.delete()

      this.convertImageToThreeGrayScale(outputCanvasId)
      this.attachTone(outputCanvasId)
    },
    // トーンを貼る
    attachTone (canvasId) {
      // キャンバス全体のピクセル情報を取得
      const canvas = this.$refs[canvasId]
      const ctx = canvas.getContext('2d')
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
      const width = imageData.width
      const height = imageData.height
      const pixels = imageData.data // ピクセル配列：RGBA4要素で1ピクセル

      const screenCanvas = this.$refs.screenCanvas
      const screenCtx = screenCanvas.getContext('2d')
      const screenImageData = screenCtx.getImageData(0, 0, screenCanvas.width, screenCanvas.height)
      const screenPixels = screenImageData.data // ピクセル配列：RGBA4要素で1ピクセル

      for (let y = 0; y < height; ++y) {
        for (let x = 0; x < width; ++x) {
          let base = (y * width + x) * 4
          if (pixels[base + 0] === 178) {
            pixels[base + 0] = screenPixels[base + 0]
            pixels[base + 1] = screenPixels[base + 1]
            pixels[base + 2] = screenPixels[base + 2]
            pixels[base + 3] = screenPixels[base + 3]
          }
        }
      }

      const outputCanvas = this.$refs[canvasId]
      outputCanvas.width = width
      outputCanvas.height = height
      const outputContext = outputCanvas.getContext('2d')
      outputContext.putImageData(imageData, 0, 0)
    },
    // canvasの画像を重ねていく
    createResultImage (canvasIds) {
      return new Promise((resolve, reject) => {
        const resultCanvas = this.$refs['resultCanvas']
        const resultContext = resultCanvas.getContext('2d')
        
        for (let i = 0; i < canvasIds.length; i++) {
          const canvas = this.$refs[canvasIds[i]]
          const base64 = canvas.toDataURL('image/png')
          const img = new Image()

          img.src = base64
          img.onload = function () {
            resultContext.drawImage(img, 0, 0, canvas.width, canvas.height)
            if (i === (canvasIds.length - 1)) resolve()
          }

          if (i === 0) {
            resultCanvas.width = canvas.width
            resultCanvas.height = canvas.height
          }
        }
      })
    },
    showResultImage () {
      const resultCanvas = this.$refs['resultCanvas']
      this.resultBase64 = resultCanvas.toDataURL('image/png')
    }
  }
}
</script>
